import request from 'checkout/utils/axios'

const putServices = async params => {
  const response = await request
    .post('/api/v3/carts/services', { ...params })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export default putServices
